export default __webpack_public_path__ + "static/media/target.inline.a3d18a1c.svg";